"use strict";
import flatpickr from "flatpickr";

export const searchForm = (data) => ({
    data,
    locations: data.locations,
    location: data.values.location,
    maxGuests: data.maxGuests,
    showLocations: false,
    showDatePicker: false,
    datePickerElement: document.getElementById('rangeDatePicker'),
    datePicker: null,
    areaType: data.values.areaType,
    checkIn: data.values.checkIn,
    guests: data.values.guests,
    checkOut: data.values.checkOut,
    closeAfterLocationSelection: data.closeAfterLocationSelection,
    showDateAfterLocationClosing: data.showDateAfterLocationClosing,
    closeDatePickerAfterSelection: data.closeDatePickerAfterSelection,
    onShowDatePicker() {
        if (this.datePicker === null) {
            this.datePicker = flatpickr(this.datePickerElement, {
                inline: true,
                mode: 'range',
                showMonths: 2,
                minDate: new Date().fp_incr(1),
                dateFormat: "Y-m-d",
                localeDateStringFormat: {
                    month: 'short',
                    day: 'numeric',
                    year: '2-digit'
                },
                onChange: (selectedDates, dateStr, instance) => {
                    const format = {
                        month: 'short',
                        day: 'numeric',
                        year: '2-digit'
                    };
                    if (selectedDates.length > 0) {
                        this.checkIn = selectedDates[0].toLocaleDateString('en-US', format)
                    }
                    if (selectedDates.length > 1) {
                        this.checkOut = selectedDates[1].toLocaleDateString('en-US', format)
                        if (this.closeDatePickerAfterSelection) {
                            this.showDatePicker = false;
                        }
                    }
                }
            });
        }
    },
    increaseGuests() {
        if (this.guests < this.maxGuests) {
            this.guests = (this.guests ?? 0) + 1;
        }
    },
    decreaseGuests() {
        this.guests = (this.guests ?? 0) - 1;
        if (this.guests < 1) {
            this.guests = null;
        }
    },
    openLocations() {
        if (this.canOpen()) {
            this.showLocations = true;
        }
    },
    openDatePicker() {
        if (this.canOpen()) {
            this.showDatePicker = true;
        }
    },
    canOpen() {
        return !this.showLocations && !this.showDatePicker;
    },
    close() {
        this.showLocations = false;
        this.showDatePicker = false;
    },
    setLocation(location, areaType) {
        this.location = this.location === location ? '' : location;
        this.areaType = this.location.length ? areaType : '';
        if (this.closeAfterLocationSelection) {
            this.close();
            if (this.showDateAfterLocationClosing) {
                this.showDatePicker = true;
            }
        }
    }
})